"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var eth_sig_util_1 = require("@metamask/eth-sig-util");
// cannot be dynamically imported
var buffer_1 = require("buffer");
var getAccount = function (_a, asset, index, provider) {
    var publicKey = _a.publicKey, chainCode = _a.chainCode, path = _a.path;
    return __awaiter(void 0, void 0, void 0, function () {
        var HDKey, ethUtil, _b, publicToAddress, toChecksumAddress, hdk, dkey, address;
        var _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('hdkey')); })];
                case 1:
                    HDKey = (_e.sent())["default"];
                    return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('ethereumjs-util')); })];
                case 2:
                    ethUtil = _e.sent();
                    _b = ethUtil["default"] || ethUtil, publicToAddress = _b.publicToAddress, toChecksumAddress = _b.toChecksumAddress;
                    hdk = new HDKey();
                    hdk.publicKey = buffer_1.Buffer.from(publicKey, 'hex');
                    hdk.chainCode = buffer_1.Buffer.from(chainCode, 'hex');
                    dkey = hdk.deriveChild(index);
                    address = toChecksumAddress("0x".concat(publicToAddress(dkey.publicKey, true).toString('hex')));
                    _c = {
                        derivationPath: "".concat(path, "/").concat(index),
                        address: address
                    };
                    _d = {
                        asset: asset.label
                    };
                    return [4 /*yield*/, provider.getBalance(address)];
                case 3: return [2 /*return*/, (_c.balance = (_d.value = _e.sent(),
                        _d),
                        _c)];
            }
        });
    });
};
var getAddresses = function (account, asset, provider) { return __awaiter(void 0, void 0, void 0, function () {
    var accounts, index, zeroBalanceAccounts, acc;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                accounts = [];
                index = 0;
                zeroBalanceAccounts = 0;
                _a.label = 1;
            case 1:
                if (!(zeroBalanceAccounts < 5)) return [3 /*break*/, 3];
                return [4 /*yield*/, getAccount(account, asset, index, provider)];
            case 2:
                acc = _a.sent();
                if (acc &&
                    acc.hasOwnProperty('balance') &&
                    acc.balance.hasOwnProperty('value') &&
                    acc.balance.value.isZero()) {
                    zeroBalanceAccounts++;
                    accounts.push(acc);
                }
                else {
                    accounts.push(acc);
                    // Reset the number of 0 balance accounts
                    zeroBalanceAccounts = 0;
                }
                index++;
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/, accounts];
        }
    });
}); };
function trezor(options) {
    var _this = this;
    var getIcon = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icon')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); };
    return function (_a) {
        var device = _a.device;
        var _b = options || {}, email = _b.email, appUrl = _b.appUrl, customNetwork = _b.customNetwork, filter = _b.filter, basePaths = _b.basePaths, assets = _b.assets;
        if (!email || !appUrl) {
            throw new Error('Email and AppUrl required in Trezor options for Trezor Wallet Connection');
        }
        var filtered = Array.isArray(filter) &&
            (filter.includes(device.type) || filter.includes(device.os.name));
        if (filtered)
            return null;
        var accounts;
        return {
            label: 'Trezor',
            getIcon: getIcon,
            getInterface: function (_a) {
                var EventEmitter = _a.EventEmitter, chains = _a.chains;
                return __awaiter(_this, void 0, void 0, function () {
                    function getAddress(path) {
                        return __awaiter(this, void 0, void 0, function () {
                            var errorMsg, result, error_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        errorMsg = "Unable to derive address from path ".concat(path);
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 3, , 4]);
                                        return [4 /*yield*/, TrezorConnect.ethereumGetAddress({
                                                path: path,
                                                showOnTrezor: true
                                            })];
                                    case 2:
                                        result = _a.sent();
                                        if (!result.success) {
                                            throw new Error(errorMsg);
                                        }
                                        return [2 /*return*/, result.payload.address.toLowerCase()];
                                    case 3:
                                        error_1 = _a.sent();
                                        console.error(error_1);
                                        throw new Error(errorMsg);
                                    case 4: return [2 /*return*/];
                                }
                            });
                        });
                    }
                    function getPublicKey(dPath) {
                        return __awaiter(this, void 0, void 0, function () {
                            var result, error_2;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!dPath) {
                                            throw new Error('a derivation path is needed to get the public key');
                                        }
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 3, , 4]);
                                        return [4 /*yield*/, TrezorConnect.getPublicKey({
                                                path: dPath,
                                                coin: 'ETH'
                                            })];
                                    case 2:
                                        result = _a.sent();
                                        if (!result.success) {
                                            throw new Error(result.payload.error);
                                        }
                                        account = {
                                            publicKey: result.payload.publicKey,
                                            chainCode: result.payload.chainCode,
                                            path: result.payload.serializedPath
                                        };
                                        return [2 /*return*/, account];
                                    case 3:
                                        error_2 = _a.sent();
                                        throw error_2;
                                    case 4: return [2 /*return*/];
                                }
                            });
                        });
                    }
                    function createTrezorTransactionObject(transactionData) {
                        if (!transactionData ||
                            (!transactionData.hasOwnProperty('gasLimit') &&
                                !transactionData.hasOwnProperty('gas'))) {
                            throw new Error('There was no Transaction Object or both the gasLimit and gas property are missing');
                        }
                        var gasLimit = transactionData.gasLimit || transactionData.gas;
                        if (transactionData.maxFeePerGas ||
                            transactionData.maxPriorityFeePerGas) {
                            return {
                                to: transactionData.to,
                                value: transactionData.value || '',
                                gasLimit: gasLimit,
                                maxFeePerGas: transactionData.maxFeePerGas,
                                maxPriorityFeePerGas: transactionData.maxPriorityFeePerGas,
                                nonce: transactionData.nonce,
                                chainId: Number(currentChain.id),
                                data: transactionData.hasOwnProperty('data')
                                    ? transactionData.data
                                    : ''
                            };
                        }
                        return {
                            to: transactionData.to,
                            value: transactionData.value || '',
                            gasPrice: transactionData.gasPrice,
                            gasLimit: gasLimit,
                            nonce: transactionData.nonce,
                            chainId: Number(currentChain.id),
                            data: transactionData.hasOwnProperty('data')
                                ? transactionData.data
                                : ''
                        };
                    }
                    function trezorSignTransaction(path, transactionData) {
                        try {
                            return TrezorConnect.ethereumSignTransaction({
                                path: path,
                                transaction: transactionData
                            });
                        }
                        catch (error) {
                            throw new Error("There was an error signing transaction - Error: ".concat(error));
                        }
                    }
                    function signTransaction(transactionObject) {
                        return __awaiter(this, void 0, void 0, function () {
                            var signingAccount, derivationPath, address, signer, populatedTransaction, updateBigNumberFields, transactionData, chainId, common, trezorResult, message, signedTx;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!Array.isArray(accounts) || !accounts.length)
                                            throw new Error('No account selected. Must call eth_requestAccounts first.');
                                        if (transactionObject.hasOwnProperty('from')) {
                                            signingAccount = accounts.find(function (account) { return account.address === transactionObject.from; });
                                        }
                                        signingAccount = signingAccount ? signingAccount : accounts[0];
                                        derivationPath = signingAccount.derivationPath, address = signingAccount.address;
                                        transactionObject.gasLimit =
                                            transactionObject.gas || transactionObject.gasLimit;
                                        // 'gas' is an invalid property for the TransactionRequest type
                                        delete transactionObject.gas;
                                        signer = ethersProvider.getSigner(address);
                                        return [4 /*yield*/, signer.populateTransaction(transactionObject)];
                                    case 1:
                                        populatedTransaction = _a.sent();
                                        if (populatedTransaction.hasOwnProperty('nonce') &&
                                            typeof populatedTransaction.nonce === 'number') {
                                            populatedTransaction.nonce =
                                                populatedTransaction.nonce.toString(16);
                                        }
                                        if (populatedTransaction.hasOwnProperty('nonce') &&
                                            typeof populatedTransaction.nonce === 'string') {
                                            // Adds "0x" to a given `String` if it does not already start with "0x".
                                            populatedTransaction.nonce = ethUtil.addHexPrefix(populatedTransaction.nonce);
                                        }
                                        updateBigNumberFields = bigNumberFieldsToStrings(populatedTransaction);
                                        transactionData = createTrezorTransactionObject(updateBigNumberFields);
                                        transactionData.from = address;
                                        chainId = currentChain.hasOwnProperty('id')
                                            ? Number(currentChain.id)
                                            : 1;
                                        return [4 /*yield*/, getCommon({ customNetwork: customNetwork, chainId: chainId })];
                                    case 2:
                                        common = _a.sent();
                                        return [4 /*yield*/, trezorSignTransaction(derivationPath, transactionData)];
                                    case 3:
                                        trezorResult = _a.sent();
                                        if (!trezorResult.success) {
                                            message = trezorResult.payload.error === 'Unknown message'
                                                ? 'This type of transactions is not supported on this device'
                                                : trezorResult.payload.error;
                                            throw new Error(message);
                                        }
                                        if (transactionData.maxFeePerGas ||
                                            transactionData.maxPriorityFeePerGas) {
                                            signedTx = FeeMarketEIP1559Transaction.fromTxData(__assign(__assign({}, transactionData), trezorResult.payload), { common: common });
                                        }
                                        else {
                                            signedTx = Transaction.fromTxData(__assign(__assign({}, transactionData), trezorResult.payload), { common: common });
                                        }
                                        return [2 /*return*/, signedTx ? "0x".concat(signedTx.serialize().toString('hex')) : ''];
                                }
                            });
                        });
                    }
                    function signMessage(address, message) {
                        return __awaiter(this, void 0, void 0, function () {
                            var accountToSign;
                            return __generator(this, function (_a) {
                                if (!Array.isArray(accounts) || !accounts.length)
                                    throw new Error('No account selected. Must call eth_requestAccounts first.');
                                accountToSign = accounts.find(function (account) { return account.address === address; }) ||
                                    accounts[0];
                                return [2 /*return*/, new Promise(function (resolve, reject) {
                                        TrezorConnect.ethereumSignMessage({
                                            path: accountToSign.derivationPath,
                                            message: ethUtil.stripHexPrefix(message.data),
                                            hex: true
                                        }).then(function (response) {
                                            if (response.success) {
                                                if (response.payload.address !==
                                                    ethUtil.toChecksumAddress(address)) {
                                                    reject(new Error('signature doesnt match the right address'));
                                                }
                                                var signature = "0x".concat(response.payload.signature);
                                                resolve(signature);
                                            }
                                            else {
                                                reject(new Error((response.payload && response.payload.error) ||
                                                    'There was an error signing a message'));
                                            }
                                        });
                                    })];
                            });
                        });
                    }
                    var Trezor, _b, Transaction, FeeMarketEIP1559Transaction, _c, createEIP1193Provider, ProviderRpcError, accountSelect, _d, getCommon, bigNumberFieldsToStrings, getHardwareWalletProvider, ethUtil, compress, StaticJsonRpcProvider, TrezorConnect, eventEmitter, currentChain, account, ethersProvider, scanAccounts, getAccountFromAccountSelect, trezorProvider, provider;
                    var _this = this;
                    return __generator(this, function (_e) {
                        switch (_e.label) {
                            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('trezor-connect')); })];
                            case 1:
                                Trezor = (_e.sent())["default"];
                                return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('@ethereumjs/tx')); })];
                            case 2:
                                _b = _e.sent(), Transaction = _b.Transaction, FeeMarketEIP1559Transaction = _b.FeeMarketEIP1559Transaction;
                                return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('@sovryn/onboard-common')); })];
                            case 3:
                                _c = _e.sent(), createEIP1193Provider = _c.createEIP1193Provider, ProviderRpcError = _c.ProviderRpcError;
                                return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('@sovryn/onboard-hw-common')); })];
                            case 4:
                                accountSelect = (_e.sent()).accountSelect;
                                return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('@sovryn/onboard-hw-common')); })];
                            case 5:
                                _d = _e.sent(), getCommon = _d.getCommon, bigNumberFieldsToStrings = _d.bigNumberFieldsToStrings, getHardwareWalletProvider = _d.getHardwareWalletProvider;
                                return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('ethereumjs-util')); })];
                            case 6:
                                ethUtil = _e.sent();
                                return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('eth-crypto')); })];
                            case 7:
                                compress = (_e.sent()).publicKey.compress;
                                return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('@ethersproject/providers')); })];
                            case 8:
                                StaticJsonRpcProvider = (_e.sent()).StaticJsonRpcProvider;
                                TrezorConnect = Trezor["default"] || Trezor;
                                TrezorConnect.manifest({
                                    email: email,
                                    appUrl: appUrl
                                });
                                eventEmitter = new EventEmitter();
                                currentChain = chains[0];
                                scanAccounts = function (_a) {
                                    var derivationPath = _a.derivationPath, chainId = _a.chainId, asset = _a.asset;
                                    return __awaiter(_this, void 0, void 0, function () {
                                        var _b, publicKey, chainCode, path, address;
                                        var _c, _d;
                                        return __generator(this, function (_e) {
                                            switch (_e.label) {
                                                case 0:
                                                    currentChain =
                                                        chains.find(function (_a) {
                                                            var id = _a.id;
                                                            return id === chainId;
                                                        }) || currentChain;
                                                    ethersProvider = new StaticJsonRpcProvider(currentChain.rpcUrl);
                                                    return [4 /*yield*/, getPublicKey(derivationPath)];
                                                case 1:
                                                    _b = _e.sent(), publicKey = _b.publicKey, chainCode = _b.chainCode, path = _b.path;
                                                    if (!!basePaths.find(function (item) { return item.value === derivationPath; })) return [3 /*break*/, 4];
                                                    return [4 /*yield*/, getAddress(path)];
                                                case 2:
                                                    address = _e.sent();
                                                    _c = {
                                                        derivationPath: derivationPath,
                                                        address: address
                                                    };
                                                    _d = {
                                                        asset: asset.label
                                                    };
                                                    return [4 /*yield*/, ethersProvider.getBalance(address.toLowerCase())];
                                                case 3: return [2 /*return*/, [
                                                        (_c.balance = (_d.value = _e.sent(),
                                                            _d),
                                                            _c)
                                                    ]];
                                                case 4: return [2 /*return*/, getAddresses({
                                                        publicKey: compress(publicKey),
                                                        chainCode: chainCode || '',
                                                        path: derivationPath
                                                    }, asset, ethersProvider)];
                                            }
                                        });
                                    });
                                };
                                getAccountFromAccountSelect = function () { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, accountSelect({
                                                    basePaths: basePaths,
                                                    assets: assets,
                                                    chains: chains,
                                                    scanAccounts: scanAccounts
                                                })];
                                            case 1:
                                                accounts = _a.sent();
                                                if (Array.isArray(accounts) &&
                                                    accounts.length &&
                                                    accounts[0].hasOwnProperty('address')) {
                                                    eventEmitter.emit('accountsChanged', [accounts[0].address]);
                                                }
                                                return [2 /*return*/, accounts];
                                        }
                                    });
                                }); };
                                trezorProvider = getHardwareWalletProvider(function () { return currentChain === null || currentChain === void 0 ? void 0 : currentChain.rpcUrl; });
                                provider = createEIP1193Provider(trezorProvider, {
                                    eth_requestAccounts: function () { return __awaiter(_this, void 0, void 0, function () {
                                        var accounts;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, getAccountFromAccountSelect()];
                                                case 1:
                                                    accounts = _a.sent();
                                                    if (!Array.isArray(accounts))
                                                        throw new Error('No account selected. Must call eth_requestAccounts first.');
                                                    if (accounts.length === 0) {
                                                        throw new ProviderRpcError({
                                                            code: 4001,
                                                            message: 'User rejected the request.'
                                                        });
                                                    }
                                                    if (!accounts[0].hasOwnProperty('address'))
                                                        throw new Error('No address property associated with the selected account');
                                                    return [2 /*return*/, [accounts[0].address]];
                                            }
                                        });
                                    }); },
                                    eth_selectAccounts: function () { return __awaiter(_this, void 0, void 0, function () {
                                        var accounts;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, getAccountFromAccountSelect()];
                                                case 1:
                                                    accounts = _a.sent();
                                                    return [2 /*return*/, accounts.map(function (_a) {
                                                            var address = _a.address;
                                                            return address;
                                                        })];
                                            }
                                        });
                                    }); },
                                    eth_accounts: function () { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            return [2 /*return*/, Array.isArray(accounts) &&
                                                    accounts.length &&
                                                    accounts[0].hasOwnProperty('address')
                                                    ? [accounts[0].address]
                                                    : []];
                                        });
                                    }); },
                                    eth_chainId: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                                        return [2 /*return*/, currentChain.hasOwnProperty('id') ? currentChain.id : ''];
                                    }); }); },
                                    eth_signTransaction: function (_a) {
                                        var transactionObject = _a.params[0];
                                        return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_b) {
                                            return [2 /*return*/, signTransaction(transactionObject)];
                                        }); });
                                    },
                                    eth_sendTransaction: function (_a) {
                                        var baseRequest = _a.baseRequest, params = _a.params;
                                        return __awaiter(_this, void 0, void 0, function () {
                                            var signedTx, transactionHash;
                                            return __generator(this, function (_b) {
                                                switch (_b.label) {
                                                    case 0: return [4 /*yield*/, provider.request({
                                                            method: 'eth_signTransaction',
                                                            params: params
                                                        })];
                                                    case 1:
                                                        signedTx = _b.sent();
                                                        return [4 /*yield*/, baseRequest({
                                                                method: 'eth_sendRawTransaction',
                                                                params: [signedTx]
                                                            })];
                                                    case 2:
                                                        transactionHash = _b.sent();
                                                        return [2 /*return*/, transactionHash];
                                                }
                                            });
                                        });
                                    },
                                    eth_sign: function (_a) {
                                        var _b = _a.params, address = _b[0], message = _b[1];
                                        return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_c) {
                                            return [2 /*return*/, signMessage(address, { data: message })];
                                        }); });
                                    },
                                    personal_sign: function (_a) {
                                        var _b = _a.params, message = _b[0], address = _b[1];
                                        return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_c) {
                                            return [2 /*return*/, signMessage(address, { data: message })];
                                        }); });
                                    },
                                    eth_signTypedData: function (_a) {
                                        var _b = _a.params, address = _b[0], typedData = _b[1];
                                        return __awaiter(_this, void 0, void 0, function () {
                                            var account, domainHash, messageHash;
                                            return __generator(this, function (_c) {
                                                if (!(accounts && accounts.length && accounts.length > 0))
                                                    throw new Error('No account selected. Must call eth_requestAccounts first.');
                                                account = accounts.find(function (account) { return account.address === address; }) ||
                                                    accounts[0];
                                                if (typeof typedData === 'string') {
                                                    typedData = JSON.parse(typedData);
                                                }
                                                domainHash = eth_sig_util_1.TypedDataUtils.hashStruct('EIP712Domain', typedData.domain, typedData.types, eth_sig_util_1.SignTypedDataVersion.V3).toString('hex');
                                                messageHash = eth_sig_util_1.TypedDataUtils.hashStruct(typedData.primaryType, typedData.message, typedData.types, eth_sig_util_1.SignTypedDataVersion.V3).toString('hex');
                                                return [2 /*return*/, TrezorConnect.ethereumSignTypedData({
                                                        path: account.derivationPath,
                                                        data: typedData,
                                                        // These are optional, but required for Trezor Model 1 compatibility
                                                        domain_separator_hash: domainHash,
                                                        message_hash: messageHash
                                                    }).then(function (result) {
                                                        if (result.success) {
                                                            return result.payload.signature;
                                                        }
                                                        throw new Error((result.payload && result.payload.error) ||
                                                            'There was an error signing a message');
                                                    })];
                                            });
                                        });
                                    },
                                    eth_signTypedData_v4: function (_a) {
                                        var _b = _a.params, address = _b[0], typedData = _b[1];
                                        return __awaiter(_this, void 0, void 0, function () {
                                            var account, domainHash, messageHash;
                                            return __generator(this, function (_c) {
                                                if (!(accounts && accounts.length && accounts.length > 0))
                                                    throw new Error('No account selected. Must call eth_requestAccounts first.');
                                                account = accounts.find(function (account) { return account.address === address; }) ||
                                                    accounts[0];
                                                if (typeof typedData === 'string') {
                                                    typedData = JSON.parse(typedData);
                                                }
                                                domainHash = eth_sig_util_1.TypedDataUtils.hashStruct('EIP712Domain', typedData.domain, typedData.types, eth_sig_util_1.SignTypedDataVersion.V4).toString('hex');
                                                messageHash = eth_sig_util_1.TypedDataUtils.hashStruct(typedData.primaryType, typedData.message, typedData.types, eth_sig_util_1.SignTypedDataVersion.V4).toString('hex');
                                                return [2 /*return*/, TrezorConnect.ethereumSignTypedData({
                                                        path: account.derivationPath,
                                                        data: typedData,
                                                        metamask_v4_compat: true,
                                                        // These are optional, but required for Trezor Model 1 compatibility
                                                        domain_separator_hash: domainHash,
                                                        message_hash: messageHash
                                                    }).then(function (result) {
                                                        if (result.success) {
                                                            return result.payload.signature;
                                                        }
                                                        throw new Error((result.payload && result.payload.error) ||
                                                            'There was an error signing a message');
                                                    })];
                                            });
                                        });
                                    },
                                    wallet_switchEthereumChain: function (_a) {
                                        var chainId = _a.params[0].chainId;
                                        return __awaiter(_this, void 0, void 0, function () {
                                            return __generator(this, function (_b) {
                                                currentChain =
                                                    chains.find(function (_a) {
                                                        var id = _a.id;
                                                        return id === chainId;
                                                    }) || currentChain;
                                                if (!currentChain)
                                                    throw new Error('chain must be set before switching');
                                                eventEmitter.emit('chainChanged', currentChain.id);
                                                return [2 /*return*/, null];
                                            });
                                        });
                                    },
                                    wallet_addEthereumChain: null
                                });
                                provider.on = eventEmitter.on.bind(eventEmitter);
                                return [2 /*return*/, {
                                        provider: provider
                                    }];
                        }
                    });
                });
            }
        };
    };
}
exports["default"] = trezor;
